// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"_doQw","hideModal":"RTnPk"};